/**
 * Customer Location Form Modal
 *
 * Thin wrapper around the shared LocationFormModal with customer-specific defaults.
 * - Uses customer translation namespace
 * - Uses isDefaultShipping and isDefaultBilling fields
 * - Uses addressLang for localized location names
 */

import SharedLocationFormModal, {
  CustomerLocationFormData,
  LocationFormData as SharedLocationFormData,
} from '@/components/shared/LocationFormModal';

// Re-export the customer-specific form data type for backward compatibility
export type LocationFormData = CustomerLocationFormData;
export type { CustomerLocationFormData };

interface LocationFormModalProps {
  visible: boolean;
  onClose: () => void;
  onSuccess: (location: LocationFormData) => void;
  location?: LocationFormData | null;
  /** When true, displays form in read-only mode (view mode) */
  readOnly?: boolean;
  /** When true, shows loading spinner instead of form */
  loading?: boolean;
}

const LocationFormModal = ({
  visible,
  onClose,
  onSuccess,
  location,
  readOnly = false,
  loading = false,
}: LocationFormModalProps) => {
  // Wrap onSuccess to cast from union type to customer-specific type
  const handleSuccess = (data: SharedLocationFormData) => {
    onSuccess(data as CustomerLocationFormData);
  };

  return (
    <SharedLocationFormModal
      visible={visible}
      onClose={onClose}
      onSuccess={handleSuccess}
      location={location}
      readOnly={readOnly}
      entityType="customer"
      loading={loading}
    />
  );
};

export default LocationFormModal;
